import { isSSR } from './isSSR.js';

var isAndroid = function isAndroid() {
  if (isSSR()) {
    return false;
  }

  if (document.documentElement.classList.contains('Android')) {
    return true;
  }

  return Boolean(/(?:Android);?[\s/]+([\d.]+)?/.exec(navigator.userAgent));
};
var platform = isAndroid() ? 'Android' : 'iOS';

export { isAndroid, platform };
//# sourceMappingURL=platform.js.map
